import { PageComponent } from "barba"
import TinySlider from "utils/tiny-slider"

class HomeHeadingClass {

    constructor({ node }) {
        this.heading = node
        this.slider = null
        
        this.sliderOpts = () => ({
            mode: this.isGallery() ? 'gallery' : 'carousel',
            container: this.heading.querySelector('.home-heading__tns'),
            prevButton: this.heading.querySelector('.home-heading__prev'),
            nextButton: this.heading.querySelector('.home-heading__next'),
            navPosition: 'bottom',
            speed: 500
        })
        
        if (this.heading.querySelectorAll('.slide-item').length > 1) {
            this.slider = new TinySlider(this.sliderOpts)
        }
    }

    isGallery() {
        return window.matchMedia("(min-width: 992px)").matches
    }

    destroy() {
        if (this.slider && this.slider.destroy) {
            this.slider.destroy()
        }
        
        delete this.heading
        delete this.sliderOpts
        delete this.slider
    }

}

new PageComponent(".home-heading", HomeHeadingClass)